






















import { Component, Watch, Vue } from 'vue-property-decorator';
import Greeting from '../../components/Greeting.vue';

@Component({
  components: {
    Greeting,
  },
})
export default class UtilityNav extends Vue {
  private screenSize: number = screen.width;

  @Watch('screenSize')
  private onchange(val: number, oldVal: number) {
    this.screenSize = val;
  }

  private mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.screenSize = window.innerWidth;
      });
    });
  }
}

